(function () {
  "use strict";

  GroupRestrictTrainerCtrl.$inject = ['$scope', '$modalInstance'];
  angular
    .module('trainerWebApp.modals')
    .controller('GroupRestrictTrainerCtrl', GroupRestrictTrainerCtrl);

  function GroupRestrictTrainerCtrl($scope, $modalInstance) {
    $scope.modal = {
      content: 0,
      permissions: $scope.selectedTrainer.permissions.toLowerCase(),
      status: '',
      confirmed: false
    };
    $scope.forceCloseDropDown(); //close select2dropdown

    $scope.setup = {
      title: 'Confirm restricting group permissions.',
      message: 'Adding this ' + $scope.modal.permissions + ' to this group will restrict their access to just this group, they will no longer have access to all users.',
      buttons: [
        {label: 'Cancel', cssClass: 'btn-general', result: 'dismiss'},
        {label: 'Restrict', cssClass: 'btn-primary', result: 'restrict'}
      ]
    };

    $scope.close = function (result) {
      if (result == 'restrict') {
        $scope.modal.status = 'saving';
        $scope.modal.confirmed = true;
        $modalInstance.close();
      }
      else
        $modalInstance.dismiss(result);
    };
  }

})();
